import { z } from 'zod'

export const INACTIVE = 'inactive'
export const ACTIVE = 'active'

export const status = z.enum([INACTIVE, ACTIVE])

export const statuses = Object.values(status.enum)

export type Status = z.infer<typeof status>
